<template>
  <paper
    :title="tab.name"
    body-class="mt-0"
  >
    <div class="px-2 pb-1">
      <b-row>
        <b-col>
          <p>
            input 1 will be selected when job template is created.
          </p>
        </b-col>
      </b-row>
    </div>
  </paper>
</template>

<script>
import // ValidationProvider,
'vee-validate'
import Paper from '@/components/paper/Paper.vue'
// import InputField from '@/components/form/InputField.vue'

export default {
  name: 'JobInputSettings',
  components: {
    Paper,
    // InputField,
    // ValidationProvider,
  },
  props: {
    tab: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      generalInformation: {
        name: '',
        category: '',
        description: '',
      },
    }
  },
}
</script>

<style></style>
